import CustomersList from "@/components/CustomersList";

export default function AdminCustomers() {
  return <CustomersList role="admin" />;
}
